module.exports = __webpack_public_path__ + "static/f6e068ed-d406-4621-83b0-bdb48d51b0d1-13f8ff21b67c929b4e65cb0bb97f5e4c.jpeg";